import { useQuery } from "@tanstack/react-query";
import { useApiClient } from "../../../apiClient";
import { GetEventCountDto } from "../../../models/analytics/dto/get-event-count.dto";
import { AnalyticsFilterParams, buildFilterSuffix } from "./analyticsFilterParams";

export const GET_EVENT_COUNT_QUERY_KEY = 'eventCount';

export const useGetEventCount = (locationId: string, startDate?: Date, endDate?: Date, filters?: AnalyticsFilterParams) => {
    const apiClient = useApiClient();
    return useQuery<GetEventCountDto>({
        queryKey: [GET_EVENT_COUNT_QUERY_KEY, locationId, startDate, endDate, filters?.courtIds, filters?.sportTypes],
        queryFn: async () => {
            const suffix = startDate && endDate ? `startDate=${startDate.toISOString()}&endDate=${endDate.toISOString()}` : '';
            return apiClient.fetchApi<GetEventCountDto, {}>({ method: 'GET', endpoint: `analytics/event-count?locationId=${locationId}&${suffix}${buildFilterSuffix(filters)}` });
        },
        enabled: !!locationId,
        staleTime: 5 * 60 * 1000,
    });
}
